import React, { useEffect, useState } from 'react';
import Header from '../layouts/Header';
import Banner from '../components/contact/Banner';
import Footer from '../layouts/Footer';
import OurLocation from '../components/Home/OurLocation';
import JoinOurTeam from '../components/Home/JoinOurTeam';
import ContactForm from '../components/contact/ContactForm';
import { motion } from "motion/react";
import { Helmet } from "react-helmet";
const Contact = () => {
    const [hasLoaded, setHasLoaded] = useState(false); 

    useEffect(() => {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
      const timer = setTimeout(() => setHasLoaded(true), 100);
      return () => clearTimeout(timer);
    }, []);

  return (
    <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: hasLoaded ? 1 : 0 }}
    transition={{ duration: 0.7 }}
  >
        <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
    <div className='volto-homepage contact'>
     <Header mode="light" />
     <Banner />
     <ContactForm />
     <OurLocation viewMaps={false} showAddress={true}  />
     <Footer />
    </div>
    </motion.div>
  )
}

export default Contact
